import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3932a962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-calendar" }
const _hoisted_2 = { class: "side-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "side-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: "https://jstd-auxi.oss-cn-hangzhou.aliyuncs.com/auxi/2024-09-09/a3dd65b7bebe5ef3d7924208256221e8.png"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "我的日程")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "side-button" }, null, -1))
const _hoisted_5 = { class: "side-selector" }
const _hoisted_6 = ["date"]
const _hoisted_7 = { class: "side-tag" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"relative","width":"100%"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","padding-left":"10px","border-bottom":"1px solid #eee"} }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "el-icon-menu",
      style: {"margin-right":"5px"}
    }),
    /*#__PURE__*/_createTextVNode("日程标签 ")
  ])
], -1))
const _hoisted_9 = { class: "tag-name" }
const _hoisted_10 = {
  id: "tagIcon",
  class: "tag-icon"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "page-info" }
const _hoisted_14 = { class: "tag-color" }
const _hoisted_15 = { class: "dialog-footer" }
const _hoisted_16 = { class: "tag-color" }
const _hoisted_17 = { class: "calendar-option" }
const _hoisted_18 = {
  class: "calendar-option-extra",
  style: {"width":"20px"}
}
const _hoisted_19 = { class: "calendar-option" }
const _hoisted_20 = { class: "calendar-option-name" }
const _hoisted_21 = { class: "calendar-option" }
const _hoisted_22 = { class: "calendar-option-name" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或"),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "不超过20m", -1))
const _hoisted_26 = {
  key: 0,
  class: "dialog-footer"
}

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import { computed, h, onMounted, reactive, ref, render } from 'vue'
import { Calendar, DateSelectArg, DatesSetArg } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import zhCnLocale from '@fullcalendar/core/locales/zh-cn'
import bootstrap5Plugin from '@fullcalendar/bootstrap5'
import zhLocale from 'element-plus/es/locale/lang/zh-cn'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {
  createPageData,
  deletePageData,
  editPageData,
  getListData
} from '@/service/main/system'
import { ElMessageBox, ElPopover, ElProgress } from 'element-plus'
import { useUpload } from '@/hooks/useUpload'
import { UploadFile } from 'element-plus/lib/el-upload/src/upload.type'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'desktop',
  setup(__props) {

const store = useStore()
const userInfo = store.state.login.userInfo
const calendarRef = ref(null)
const isFold = ref(false)
const currentDate = ref(new Date())
const currentMonth = computed(() => {
  return dayjs(currentDate.value.toISOString().substring(0, 10)).format(
    'YYYY年MM月'
  )
})
const addTagDialog = ref(false)

const activeNames = ref(['1'])
const tagList: any = ref([])
// const taskStatus = ref([
//   { id: 0, name: '未开始', color: '#909399' },
//   { id: 1, name: '进行中', color: '#3b64fc' },
//   { id: 2, name: '已完成', color: '#67c23a' }
// ])
// const checkStatusList = ref([0, 1, 2])
//
// const warnStatus = ref([
//   { id: 0, name: '临期', color: '#fcc713' },
//   { id: 1, name: '超期', color: '#f50202' }
// ])
// const checkWarnList = ref([0, 1])

const loadTagList = () => {
  getListData('/main/calendarTag/listDictTag', {}).then((res) => {
    tagList.value = res
      .filter((o: any) => o.selected == 1)
    checkList.value = res
      .filter((o: any) => o.selected == 1)
      .map((o: any) => o.id)
    loadEventList()
  })
}
const empList = ref([])
const loadEmpList = async () => {
  empList.value = await getListData('/main/employee/queryEmpList', {})
}

const tagForm = ref({
  id: '',
  name: '',
  color: '',
  selected: 1
})

const predefineColors = ref([
  '#ff4500',
  '#ff8c00',
  '#ffd700',
  '#90ee90',
  '#00ced1',
  '#1e90ff',
  '#c71585',
  'rgba(255, 69, 0, 0.68)',
  'rgb(255, 120, 0)',
  'hsv(51, 100, 98)',
  'hsva(120, 40, 94, 0.5)',
  'hsl(181, 100%, 37%)',
  'hsla(209, 100%, 56%, 0.73)',
  '#c7158577'
])

const checkList: any = ref([])

const tempDate: any = ref(null)

const onScroll = (e: Event) => {
  const scrollTop = (e.target as HTMLElement).scrollTop
  store.commit('system/updateScrollPosition', scrollTop)
}

const calendar = ref<Calendar | null>(null)

dayjs.locale('zh-CN', {
  weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
  weekStart: 1
})

const initializeCalendar = () => {
  const calendarEl = calendarRef.value
  if (calendarEl) {
    calendar.value = new Calendar(calendarEl, {
      height: '865px',
      plugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        bootstrap5Plugin
      ],
      locale: zhCnLocale,
      themeSystem: 'bootstrap5',
      customButtons: {
        sideBar: {
          icon: 'layout-text-sidebar',
          click: function () {
            isFold.value = !isFold.value
          }
        }
      },
      buttonText: {
        today: '今'
      },
      headerToolbar: {
        left: 'sideBar today prev,next',
        center: 'title',
        right: 'timeGridDay,timeGridWeek,dayGridMonth'
      },
      initialView: 'dayGridMonth',
      dayCellContent: renderContent,
      eventContent: renderEvContent,
      dayCellClassNames: 'cellFont',
      weekends: true,
      navLinks: true,
      events: [],
      eventClick: (info) => {
        // editEvent(info.event.id)
        let index = parseInt(info.event.extendedProps.tagId) - 1
        if (
          tagList.value[index].options.link518 ||
          tagList.value[index].options.link
        ) {
          if (userInfo.empTag == '0') {
            router.push(tagList.value[index].options.link518)
          } else {
            router.push(tagList.value[index].options.link)
          }
        }
      },
      eventOrder: (eventA: any, eventB: any) => {
        return eventA.tagId - eventB.tagId
      },
      select: function (arg: DateSelectArg) {
        if (currentDate.value.getMonth() != arg.start.getMonth()) {
          tempDate.value = arg.start
          calendar.value?.gotoDate(arg.start)
        } else {
          currentDate.value = arg.start
          arg.jsEvent?.stopPropagation()
        }
      },
      editable: true,
      selectable: true,
      unselectAuto: false,
      eventDrop: (info) => {
        alert(`Dropped: ${info.event.title}`)
      },
      eventChange: (info) => {
        alert(`Changed: ${info.event.title}`)
      },
      datesSet: (arg: DatesSetArg) => {
        let oldMonth = currentDate.value.getMonth()
        if (tempDate.value && tempDate.value != 1) {
          currentDate.value = tempDate.value
          calendar.value?.gotoDate(tempDate.value)
          calendar.value?.select(tempDate.value)
          tempDate.value = 1
        } else if (!tempDate.value) {
          currentDate.value = findFirstDay(arg.start, arg.end)
          calendar.value?.select(currentDate.value)
        } else {
          tempDate.value = null
        }
        if (oldMonth != currentDate.value.getMonth()) {
          loadEventList()
        }
      }
    })

    calendar.value.render()
  }
}

const renderContent = (info: any) => {
  let htmlStr = ''
  if (info.date.getDate() == 1) {
    htmlStr = dayjs(info.date.toISOString()).format('M月D日')
  } else {
    htmlStr = dayjs(info.date.toISOString()).format('D')
  }
  return htmlStr
}

const buttonRef = ref()

const renderEvContent = (info: any) => {
  if (info.event.extendedProps.tagId == 1) {
    let updateCount = info.event.extendedProps.extend.updatedCount
      ? info.event.extendedProps.extend.updatedCount
      : info.event.extendedProps.extend.empFinish
      ? info.event.extendedProps.extend.empFinish
      : 0
    let customCount = info.event.extendedProps.extend.customCount
      ? info.event.extendedProps.extend.customCount
      : info.event.extendedProps.extend.empCount
      ? info.event.extendedProps.extend.empCount
      : 0
    let percent = (updateCount * 100) / customCount
    const container = document.createElement('div')
    container.setAttribute('title', info.event.title)
    const vnode = h(ElProgress, {
      ref: buttonRef,
      textInside: true,
      percentage: percent.toFixed(2),
      strokeWidth: 20,
      color: info.event.extendedProps.progressColor,
      format: (percentage: number) => {
        return `今日沟通计划完成度： ${percentage}%`
      }
    })
    render(vnode, container)
    return {
      html: container.outerHTML
    }
  } else if (info.event.extendedProps.tagId == 2) {
    let updateCount = info.event.extendedProps.extend.customEnd
    let customCount = info.event.extendedProps.extend.customTotal
    let percent = (updateCount * 100) / customCount
    const container = document.createElement('div')
    container.setAttribute('title', info.event.title)
    const vnode = h(ElProgress, {
      ref: buttonRef,
      textInside: true,
      percentage: percent.toFixed(2),
      strokeWidth: 20,
      color: info.event.extendedProps.progressColor,
      format: (percentage: number) => {
        return `今日成交进度： ${percentage}%`
      }
    })
    render(vnode, container)
    return {
      html: container.outerHTML
    }
  } else if (info.event.extendedProps.tagId == 3) {
    let verifyPass = info.event.extendedProps.extend.verifyPass
    let verifyReject = info.event.extendedProps.extend.verifyReject
    let reportTotal = info.event.extendedProps.extend.reportTotal
    let percent = (verifyPass * 100) / reportTotal
    const container = document.createElement('div')
    container.setAttribute('title', info.event.title)

    const vnode = h(ElProgress, {
      ref: buttonRef,
      textInside: true,
      percentage: percent.toFixed(2),
      strokeWidth: 20,
      color: info.event.extendedProps.progressColor,
      format: (percentage: number) => {
        return `资金量核实通过率： ${percentage}%`
      }
    })
    render(vnode, container)
    return {
      html: container.outerHTML
    }
  } else if (info.event.extendedProps.tagId == 4 || info.event.extendedProps.tagId == 5 || info.event.extendedProps.tagId == 6 || info.event.extendedProps.tagId == 7) {
    return {
      html:
        '<span style="font-size: 12px; margin-left: 5px; width:100%; white-space:normal">' +
        info.event.title +
        '</span>'
    }
  }
}

const findFirstDay = (start: Date, end: Date) => {
  let current = new Date(start)

  // 将日期重置为当月的第一天
  current.setDate(1)

  // 检查当前日期是否在范围内
  while (current <= end) {
    if (current >= start) {
      const tempDate = new Date()
      // 如果找到的1号是当前月份的1号，则返回当前日期
      if (current.getMonth() === tempDate.getMonth()) {
        return tempDate
      }
      // 否则，返回找到的第一个1号
      return current
    }
    // 移动到下个月的1号
    current.setMonth(current.getMonth() + 1)
    current.setDate(1)
  }

  // 如果没有找到合适的1号，返回起始日期
  return start
}

const handleCalendarClick = (event: Event) => {
  // 获取点击的日期
  const target = event.target as HTMLElement
  const dateStr = target.getAttribute('date')
  if (dateStr) {
    const date = new Date(dateStr)
    if (date.getMonth() != currentDate.value.getMonth()) {
      tempDate.value = date
      calendar.value?.gotoDate(date)
    }
    currentDate.value = date
    calendar.value?.select(date)
  }
  if (target.textContent == '上个月') {
    calendar.value?.prev()
  } else if (target.textContent == '今天') {
    calendar.value?.today()
  } else if (target.textContent == '下个月') {
    calendar.value?.next()
  }
}

const previewImgUrl = ref(window.location.origin + '/previewImg.html?url=')

const handlePreview = (file: any) => {
  if (file.url.match(/\.(jpg|jpeg|png|gif)$/)) {
    // 获取屏幕的宽度和高度
    const screenWidth = window.screen.width
    const screenHeight = window.screen.height

    const width = screenWidth * 0.5
    const height = screenWidth * 0.5

    // 计算新窗口的左上角位置，使其居中
    const leftPosition = screenWidth / 2 - width / 2
    const topPosition = screenHeight / 2 - height / 2

    // 创建弹出窗口
    const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
    window.open(previewImgUrl.value + file.url, '图片预览', options)
  } else {
    window.open(file.url, '_blank')
  }
}

const handleRemove = (file: UploadFile) => {
  fileList.value = fileList.value.filter((f: UploadFile) => f.url !== file.url)
  files.value = files.value.filter((f: string) => f !== file.url)
}

const formatDay = ({ day }: any) => {
  return Number(day.split('-')[2])
}

const getColor = (color: string): string => {
  return color
}

const addTag = () => {
  addTagDialog.value = true
  tagForm.value = {
    id: '',
    name: '',
    color: '',
    selected: 1
  }
}

const editTag = (ck: any) => {
  addTagDialog.value = true
  tagForm.value = {
    id: ck.id,
    name: ck.name,
    color: ck.color,
    selected: ck.selected
  }
}

const deleteTag = (id: number) => {
  ElMessageBox.confirm('确认要删除该标签吗？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    const pageUrl = `/main/calendarTag/${tagForm.value.id}`
    deletePageData(pageUrl).then(() => {
      loadTagList()
    })
  })
}

const submitAddTag = () => {
  if (tagForm.value.id) {
    const pageUrl = `/main/calendarTag/${tagForm.value.id}`
    editPageData(pageUrl, {
      ...tagForm.value
    }).then((res) => {
      addTagDialog.value = false
      loadTagList()
    })
  } else {
    createPageData('/main/calendarTag/add', {
      ...tagForm.value
    }).then((res) => {
      addTagDialog.value = false
      loadTagList()
    })
  }
}

const [
  uploadRef,
  extraData,
  files,
  action,
  beforeUpload,
  proveUpload,
  onSuccess,
  onExceed
] = useUpload()
const fileList = ref<any[]>([])

const eventForm = ref<any>({
  id: '',
  title: '',
  dates: '',
  allDay: '',
  tagId: '',
  empIds: [],
  content: '',
  isRemind: 0,
  remindEarly: '',
  eventType: 0,
  createdBy: '',
  backgroundColor: ''
})
const addEventDialog = ref(false)

const modalTitle = ref('新增日程')
const otherInfo = reactive({
  eventLink: ''
})

const getNearestHour = () => {
  let now = dayjs() // 获取当前时间
  const currentMinutes = now.minute() // 获取当前时间的分钟数

  // 如果当前分钟数不为0，则将时间设置到下一个整点
  if (currentMinutes !== 0) {
    now = now
      .add(60 - currentMinutes, 'minute')
      .second(0)
      .millisecond(0)
  }

  return now
}

const changeAllDay = () => {
  if (eventForm.value.allDay == 1) {
    eventForm.value.dates = [
      dayjs(currentDate.value.toISOString()).format('YYYY-MM-DD'),
      dayjs(currentDate.value.toISOString()).format('YYYY-MM-DD')
    ]
  } else {
    let startDate = dayjs(currentDate.value.toISOString())
      .format('YYYY-MM-DD')
      .concat(' 08:00:00')
    let endDate = dayjs(currentDate.value.toISOString())
      .format('YYYY-MM-DD')
      .concat(' 09:00:00')
    const date = dayjs(currentDate.value.toISOString())
    const today = dayjs()
    if (date.isSame(today, 'day')) {
      // 获取当前时间之后最近的一个整点
      startDate = getNearestHour().format('YYYY-MM-DD HH:mm:ss')
      endDate = getNearestHour().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
    }
    eventForm.value.dates = [startDate, endDate]
  }
}

const eventFormDisabled = ref(true)

const addEvent = () => {
  addEventDialog.value = true
  eventFormDisabled.value = false
  let startDate = dayjs(currentDate.value.toISOString())
    .format('YYYY-MM-DD')
    .concat(' 08:00:00')
  let endDate = dayjs(currentDate.value.toISOString())
    .format('YYYY-MM-DD')
    .concat(' 09:00:00')
  const date = dayjs(currentDate.value.toISOString())
  const today = dayjs()
  if (date.isSame(today, 'day')) {
    // 获取当前时间之后最近的一个整点
    startDate = getNearestHour().format('YYYY-MM-DD HH:mm:ss')
    endDate = getNearestHour().add(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
  }

  eventForm.value = {
    id: '',
    title: '',
    dates: [startDate, endDate],
    allDay: 0,
    tagId: '',
    empIds: [],
    content: '',
    isRemind: 0,
    remindEarly: '',
    eventType: 0
  }
  modalTitle.value = '新增课程'
  otherInfo.eventLink = ''
  fileList.value = []

  files.value = []
}

const editEvent = (itemId: any) => {
  const item = eventList.value.find((item) => item.id == itemId)

  if (item.createdBy === userInfo.id) {
    eventFormDisabled.value = false
    modalTitle.value = '编辑日程'
  } else {
    eventFormDisabled.value = true
    modalTitle.value = '查看日程'
  }
  addEventDialog.value = true
  eventForm.value = {
    id: item.id,
    title: item.title,
    dates: [item.start, item.end],
    allDay: item.allDay,
    tagId: item.tagId,
    empIds: item.empIds,
    content: item.content,
    isRemind: item.isRemind,
    remindEarly: item.remindEarly,
    eventType: item.eventType,
    color: item.color,
    tagName: item.tagName
  }
  otherInfo.eventLink = item.eventLink
  if (item.eventLink) {
    files.value.push(item.eventLink)
    fileList.value = [
      {
        name: item.eventLink.substring(item.eventLink.lastIndexOf('/') + 1),
        url: item.eventLink
      }
    ]
  } else {
    fileList.value = []
  }
}

const handleCheckChange = (data: any) => {
  loadEventList()
}

const eventList = ref<any[]>([])

const loadEventList = () => {
  calendar.value?.removeAllEventSources()
  tagList.value.forEach((item: any) => {
    console.log(checkList)
    if (item.selected && checkList.value.indexOf(item.id) != -1) {
      getListData(item.url, {
        startDate: dayjs(currentDate.value.toISOString())
          .startOf('month')
          .format('YYYY-MM-DD'),
        endDate: dayjs(currentDate.value.toISOString())
          .endOf('month')
          .format('YYYY-MM-DD'),
        color: item.color,
        pid: item.options.pid,
        template: item.options.template,
        todayTemplate: item.options.todayTemplate
      }).then((res) => {
        item.eventList = res
        calendar.value?.addEventSource(item.eventList)
      })
    }
  })
}

const submitAddEvent = () => {
  otherInfo.eventLink = files.value.join(',')
  if (eventForm.value.id) {
    const pageUrl = `/main/calendarEvents/${eventForm.value.id}`
    editPageData(pageUrl, {
      ...eventForm.value,
      ...otherInfo
    }).then((res) => {
      addEventDialog.value = false
      loadEventList()
    })
  } else {
    createPageData('/main/calendarEvents/add', {
      ...eventForm.value,
      ...otherInfo
    }).then((res) => {
      addEventDialog.value = false
      loadEventList()
    })
  }
}

onMounted(() => {
  initializeCalendar()
  loadTagList()
  // loadEventList()
  loadEmpList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_calendar = _resolveComponent("el-calendar")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          width: isFold.value ? '0' : '264px'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_config_provider, { locale: _unref(zhLocale) }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_calendar, {
                      ref: "elCalendar",
                      onClick: handleCalendarClick,
                      "model-value": currentDate.value
                    }, {
                      dateCell: _withCtx(({ data }) => [
                        _createElementVNode("div", {
                          class: "date-cell-box",
                          date: data.day
                        }, _toDisplayString(formatDay(data)), 9, _hoisted_6)
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]),
                  _: 1
                }, 8, ["locale"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_collapse, {
                  modelValue: activeNames.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeNames).value = $event)),
                  accordion: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse_item, {
                      title: "日程标签",
                      name: "1"
                    }, {
                      title: _withCtx(() => [
                        _hoisted_8
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: checkList.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkList).value = $event)),
                          onChange: handleCheckChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagList.value, (ck, index) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: index,
                                label: ck.id,
                                style: _normalizeStyle(`--color: ${getColor(ck.color)}`)
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_9, _toDisplayString(ck.name), 1),
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("i", {
                                      class: "el-icon-edit",
                                      onClick: _withModifiers(($event: any) => (editTag(ck)), ["stop","prevent"])
                                    }, null, 8, _hoisted_11),
                                    _createElementVNode("i", {
                                      class: "el-icon-delete",
                                      onClick: _withModifiers(($event: any) => (deleteTag(ck.id)), ["stop","prevent"])
                                    }, null, 8, _hoisted_12)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "style"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_container, { class: "page" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, {
              class: "page-content",
              onScrollPassive: onScroll
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    ref_key: "calendarRef",
                    ref: calendarRef
                  }, null, 512)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: addTagDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addTagDialog).value = $event)),
      title: "标签管理",
      width: "20%",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitAddTag
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (addTagDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: tagForm.value,
          "label-width": "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入标签名称",
                  modelValue: tagForm.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tagForm.value.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_el_form_item, { label: "颜色" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_color_picker, {
                    "show-alpha": "",
                    modelValue: tagForm.value.color,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tagForm.value.color) = $event)),
                    predefine: predefineColors.value
                  }, null, 8, ["modelValue", "predefine"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "默认勾选" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: tagForm.value.selected,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tagForm.value.selected) = $event)),
                    "active-value": 1,
                    "inactive-value": 0
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: addEventDialog.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((addEventDialog).value = $event)),
      title: modalTitle.value,
      width: "40%",
      "close-on-click-modal": false,
      draggable: ""
    }, {
      footer: _withCtx(() => [
        (!eventFormDisabled.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submitAddEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (addEventDialog.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 取消 ")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: eventForm.value,
          "label-width": "100px",
          disabled: eventFormDisabled.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "日程标题" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入日程标题",
                  modelValue: eventForm.value.title,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((eventForm.value.title) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  autosize: "",
                  placeholder: "请输入备注",
                  modelValue: eventForm.value.content,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((eventForm.value.content) = $event)),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_form_item, { label: "日程时间" }, {
                default: _withCtx(() => [
                  (eventForm.value.allDay === 0)
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 0,
                        modelValue: eventForm.value.dates,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((eventForm.value.dates) = $event)),
                        type: "datetimerange",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        format: "YYYY-MM-DD HH:mm:ss",
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        clearable: false
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (eventForm.value.allDay === 1)
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 1,
                        modelValue: eventForm.value.dates,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((eventForm.value.dates) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        clearable: false
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "全天" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: eventForm.value.allDay,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((eventForm.value.allDay) = $event)),
                    "active-value": 1,
                    "inactive-value": 0,
                    onChange: changeAllDay
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_form_item, { label: "标签" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (eventForm.value.tagId && !eventFormDisabled.value)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          size: "small",
                          color: 
                  tagList.value.filter((item) => item.id == eventForm.value.tagId)[0].color
                
                        }, null, 8, ["color"]))
                      : _createCommentVNode("", true),
                    (eventForm.value.tagId && eventFormDisabled.value)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          size: "small",
                          color: eventForm.value.color
                        }, null, 8, ["color"]))
                      : _createCommentVNode("", true)
                  ]),
                  (!eventFormDisabled.value)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: eventForm.value.tagId,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((eventForm.value.tagId) = $event)),
                        placeholder: "选择日程标签",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_el_tag, {
                                    size: "small",
                                    color: item.color
                                  }, null, 8, ["color"]),
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(item.name), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  (eventFormDisabled.value)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        modelValue: eventForm.value.tagId,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((eventForm.value.tagId) = $event)),
                        placeholder: "选择日程标签",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_el_option, {
                            key: eventForm.value.tagId,
                            label: eventForm.value.tagName,
                            value: eventForm.value.tagId
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_el_tag, {
                                  size: "small",
                                  color: eventForm.value.color
                                }, null, 8, ["color"]),
                                _createElementVNode("span", _hoisted_22, _toDisplayString(eventForm.value.tagName), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["label", "value"]))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "日程类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: eventForm.value.eventType,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((eventForm.value.eventType) = $event)),
                  placeholder: "选择日程类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: 0,
                      label: "仅自己可见"
                    }),
                    _createVNode(_component_el_option, {
                      value: 1,
                      label: "公开可见"
                    }),
                    _createVNode(_component_el_option, {
                      value: 2,
                      label: "指定人员可见"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (eventForm.value.eventType === 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "参与人员"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      multiple: "",
                      clearable: "",
                      modelValue: eventForm.value.empIds,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((eventForm.value.empIds) = $event)),
                      placeholder: "选择参与人员"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(empList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.realName,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "是否提醒" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: eventForm.value.isRemind,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((eventForm.value.isRemind) = $event)),
                  "active-value": 1,
                  "inactive-value": 0
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (eventForm.value.isRemind === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "提醒提前时间"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: eventForm.value.remindEarly,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((eventForm.value.remindEarly) = $event)),
                      placeholder: "选择日程标签"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, { value: 15 }, {
                          default: _withCtx(() => [
                            _createTextVNode("15 分钟")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, { value: 30 }, {
                          default: _withCtx(() => [
                            _createTextVNode("30 分钟")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_option, { value: 60 }, {
                          default: _withCtx(() => [
                            _createTextVNode("60 分钟")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "附件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  drag: "",
                  "auto-upload": true,
                  action: _unref(action),
                  data: _unref(extraData),
                  "file-list": fileList.value,
                  "on-preview": handlePreview,
                  "on-remove": handleRemove,
                  "before-upload": _unref(beforeUpload),
                  "on-success": _unref(onSuccess),
                  "on-exceed": _unref(onExceed),
                  limit: 1
                }, {
                  tip: _withCtx(() => [
                    _hoisted_25
                  ]),
                  default: _withCtx(() => [
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})